module.exports = __webpack_public_path__ + "static/media/hug-circle-mob.d394a494.jpg";